import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2, Anchor } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);

      if (!sessionIdMatch) {
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        await googleAuth(sessionId);
        // Clear the hash and navigate to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Google auth failed:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [googleAuth, navigate]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 bg-[#2B3A67] rounded-xl flex items-center justify-center">
          <Anchor className="w-7 h-7 text-white" />
        </div>
      </div>
      <Loader2 className="w-8 h-8 text-[#2B3A67] animate-spin" />
      <p className="mt-4 text-[#4A5568] font-medium">Signing you in...</p>
    </div>
  );
}
